var conversationSet = require('conversation/conversation-set');

function assign(self, set) {
    for (var m in set) {
        self[m] = set[m];
    }
}

/**
 * Implementation of ConversationSet that delegates to another instance.
 * <P>
 * A delegating conversation set may have its internal delgate replaced at any time. When replaced,
 * the previously used instance will be discarded.
 *
 * @param {Function} globalErrorHandler The fallback error handler for all conversations.
 */
module.exports = function DelegatingConversationSet(globalErrorHandler) {
    var current = conversationSet(globalErrorHandler);
    var self = this;

    assign(self, current);

    this.replace = function(err) {
        var old = current;

        current = conversationSet(globalErrorHandler);

        assign(self, current);

        old.discardAll(err);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/conversation/delegating-conversation-set.js
// module id = 1010
// module chunks = 0